import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { auth0Credentials } from './config';

const Auth0ProviderWithNavigate = ({ children }) => {
  const history = useHistory();
  const { domain, clientId } = auth0Credentials;

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/forms`,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderWithNavigate.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Auth0ProviderWithNavigate;
